<div class="card">
    <div class="grid">
        <div class="col col-12" *ngIf="this.items && this.items[0].eFCModifiedBy != null">
            <div class="surface-card border-round shadow-2 p-2 flex justify-content-center">
                <p-message style="width: 100%;" severity="info" [text]="this.modified"></p-message>
            </div>
        </div>
        <!--COMPANY INFO-->
        <div class="col col-auto xl:col-4 lg:col-12 md:col-12 sm:col-12 xs:col-12">
            <div class="surface-card border-round text-center shadow-2 p-1" style="height: 100%">
                <span class="text-xl text-center font-medium text-90">Company Info</span>
                <div class="p-3">
                    <div class="p-4 flex justify-content-center">
                        <p-floatLabel variant="on" class="w-full">
                            <input type="text" class="w-full" id="customerid" pInputText [(ngModel)]="companyName">
                            <label for="customerid">Company</label>
                        </p-floatLabel>
                    </div>
                    <div class="p-4 flex justify-content-center">
                        <p-floatLabel variant="on" class="w-full">
                            <input type="email" class="w-full" id="primaryemail" pInputText [(ngModel)]="primaryemail"
                                readonly>
                            <label for="primaryemail">Primary Email</label>
                        </p-floatLabel>
                    </div>
                    <div class="p-4 flex justify-content-center">
                        <p-floatLabel variant="on" class="w-full">
                            <input type="text" class="w-full" id="address" pInputText [(ngModel)]="address">
                            <label for="address">Address 1</label>
                        </p-floatLabel>
                    </div>
                    <div class="p-4 flex justify-content-center">
                        <p-floatLabel variant="on" class="w-full">
                            <input type="text" class="w-full" id="address2" pInputText [(ngModel)]="address2">
                            <label for="address2">Address 2</label>
                        </p-floatLabel>
                    </div>
                    <div class="p-4 flex justify-content-center">
                        <p-floatLabel variant="on" class="w-full">
                            <input type="text" class="w-full" id="pin" pInputText [(ngModel)]="address3">
                            <label for="address3">Address 3</label>
                        </p-floatLabel>
                    </div>
                    <div class="p-4 flex justify-content-center">
                        <p-floatLabel variant="on" class="w-full">
                            <input type="text" class="w-full" id="productcode" pInputText [(ngModel)]="city">
                            <label for="productcode">City</label>
                        </p-floatLabel>
                    </div>
                    <div class="p-4">
                        <p-floatLabel variant="on" [class.p-float-label-focus]="selectedState">
                            <p-dropdown id="state-dropdown" styleClass="w-full" appendTo="body" [filter]="true"
                                [options]="statesSelectItem" [(ngModel)]="selectedState"
                                optionLabel="label" optionValue="value" placeholder=" ">
                            </p-dropdown>
                            <label for="state-dropdown">State</label>
                        </p-floatLabel>
                    </div>
                    <div class="p-4 mb-4 flex justify-content-center">
                        <p-floatLabel variant="on" class="w-full">
                            <input type="text" class="w-full" id="admincount" pInputText [(ngModel)]="zip">
                            <label for="admincount">Zip</label>
                        </p-floatLabel>
                    </div>
                    <!-- <div class="absolute left-0 bottom-0 p-4">
                    <label>{{this.modified}}</label>
                </div> -->
                    <div class="absolute right-0 bottom-0 p-4">
                        <button pButton type="button" label="Update" class="p-button-secondary"
                            (click)="updateCompanyInfo()"></button>
                    </div>
                </div>
            </div>
        </div>
        <!--LICENSE INFO (Read-Only)-->
        <div class="col col-auto xl:col-4 lg:col-12 md:col-12 sm:col-12 xs:col-12">
            <div class="surface-card border-round text-center shadow-2 p-1" style="height: 100%">
                <span class="text-xl text-center font-medium text-90">License Info</span>
                <div class="p-3">
                    <div class="p-4 flex justify-content-center">
                        <p-floatLabel variant="on" class="w-full">
                            <input type="text" class="w-full" id="customerid" pInputText [(ngModel)]="customerID"
                                readonly>
                            <label for="customerid">Customer ID</label>
                        </p-floatLabel>
                    </div>
                    <div class="p-4 flex justify-content-center">
                        <p-floatLabel variant="on" class="w-full">
                            <input type="text" class="w-full" id="pin" pInputText [(ngModel)]="customerPIN" readonly>
                            <label for="pin">Customer PIN</label>
                        </p-floatLabel>
                    </div>
                    <div class="p-4 flex justify-content-center">
                        <p-floatLabel variant="on" class="w-full">
                            <input type="text" class="w-full" id="productcode" pInputText [(ngModel)]="productCode"
                                readonly>
                            <label for="productcode">Product Code</label>
                        </p-floatLabel>
                    </div>
                    <!-- <div class="p-4 flex justify-content-center">
                    <p-floatLabel variant="on" class="w-full">
                        <input type="text" class="w-full" id="admincount" pInputText [(ngModel)]="adminCount" readonly>
                        <label for="admincount">Purchased Admin Count</label>
                    </span>
                </div> -->
                    <div *ngIf="installLink != null" class="p-4 flex justify-content-center">
                        <p-floatLabel variant="on" class="w-full">
                            <input type="text" class="w-full" id="link" pInputText [(ngModel)]="installLink" readonly>
                            <label for="link">Desktop Install Link</label>
                        </p-floatLabel>
                    </div>
                    <div *ngIf="microsoftDriverLink != null" class="p-4 flex justify-content-center">
                        <p-floatLabel variant="on" class="w-full">
                            <input type="text" class="w-full" id="mdlink" pInputText [(ngModel)]="microsoftDriverLink"
                                readonly>
                            <label for="mdlink">Microsoft Driver MSOLEDBSQL</label>
                        </p-floatLabel>
                    </div>
                    <div *ngIf="crystalReportsLink != null" class="p-4 flex justify-content-center">
                        <p-floatLabel variant="on" class="w-full">
                            <input type="text" class="w-full" id="crlink" pInputText [(ngModel)]="crystalReportsLink"
                                readonly>
                            <label for="crlink">Crystal Reports</label>
                        </p-floatLabel>
                    </div>
                    <!-- <div *ngIf="version != null" class="p-4 flex justify-content-center">
                    <p-floatLabel variant="on" class="w-full">
                        <input type="text" class="w-full" id="crlink" pInputText [(ngModel)]="version" readonly>
                        <label for="crlink">eFAACT API Version</label>
                    </span>
                </div>
                <div *ngIf="environment != null" class="p-4 flex justify-content-center">
                    <p-floatLabel variant="on" class="w-full">
                        <input type="text" class="w-full" id="crlink" pInputText [(ngModel)]="eFAACTVersion" readonly>
                        <label for="crlink">eFAACT Version</label>
                    </span>
                </div> -->
                </div>
            </div>
        </div>
        <!--ADVISOR-->
        <div class="col col-auto xl:col-4 lg:col-12 md:col-12 sm:col-12 xs:col-12">
            <div class="surface-card border-round text-center shadow-2 p-1" style="height: 100%">
                <span class="text-xl text-center font-medium text-90">Advisor</span>
                <div class="p-3">
                    <div class="p-4">
                        <span>{{advisorMessage}}</span>
                    </div>
                    <div class="flex items-center p-2">
                        <p-checkbox [(ngModel)]="acknowledged" [binary]="true" inputId="binary"></p-checkbox>
                        <label for="binary" class="ml-2">{{acknowledgedMessage}}</label>
                    </div>
                    <div class="p-4 flex justify-content-center">
                        <p-dropdown placeholder="Advisor" appendTo="body" autoDisplayFirst="false"
                            [options]="advisorsSelectItem" [(ngModel)]="selectedAdvisor">
                        </p-dropdown>
                    </div>
                    <!-- <div class="absolute left-0 bottom-0 p-4">
                    <label>{{this.modified}}</label>
                </div> -->
                    <div class="absolute right-0 bottom-0 p-4">
                        <button pButton type="button" label="Update" class="p-button-secondary"
                            (click)="updateAdvisor()" [disabled]="!acknowledged"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
